import React from 'react';
import { useTranslation } from 'react-i18next';
import { MyCompanies } from '@components/templates/myAccount';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function MyCompaniesPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('my-companies-component.metatags.title'),
        description: t('my-companies-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myCompanies,
        index: false,
    });

    return <MyCompanies />;
}
